import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsHomeHealthWorkplaceMobileExperienceEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.HOME_HEALTH_WORKPLACE_MOBILE_EXPERIENCE_ENABLED, {
    defaultValue: false,
  });
}
